// src/redux/slices/newsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  loading: false,
  error: null
};

export const newsSlice = createSlice({
  name: 'newsSlice',
  initialState,
  reducers: {
    addNews: (state) => {
      state.loading = true;
    },
    getNews: (state) => {
      state.loading = true;
    },
    getOneNews: (state) => {
      state.loading = true;
    },
    updateNews: (state) => {
      state.loading = true;
    },
    removeNews: (state) => {
      state.loading = true;
    },

    successNews: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    failedNews: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { addNews, getNews, getOneNews, updateNews, removeNews, successNews, failedNews } = newsSlice.actions;

export default newsSlice.reducer;
